import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { NavLink, useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Navbar } from "react-bootstrap";
import { IoMdArrowDropdown } from "react-icons/io";
import { NavHashLink } from "react-router-hash-link";
import { HASH_SECTIONS, PATHS } from "data/paths";
import { NAV_SERVICES } from "data/navigation";
import { scrollToId } from "lib/scroll";

export default function NavBar() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();

  const handleCloseOffcanvas = () => {
    window.scrollTo(0, scrollPosition);
    setShowOffcanvas(false);
  };

  const handleHashLinkClick = (event, id) => {
    if (window.innerWidth >= 960) return;

    event.preventDefault();
    navigate(PATHS.home);
    window.setTimeout(() => {
      scrollToId(id);
      handleCloseOffcanvas();
    }, 80);
  };

  return (
    <Navbar expand="lg" className="bg-body-tertiary mb-3">
      <Container
        fluid
        className="d-flex justify-content-between align-items-baseline"
      >
        <Navbar.Brand>
          <NavLink to={PATHS.home} className="ImgNav">
            <img
              src="images/660876887abcb9a37db36343.gif"
              alt="logo"
              className="logoImg"
            />
          </NavLink>
        </Navbar.Brand>
        <Navbar.Toggle
          className="textttt"
          aria-controls="offcanvasNavbar"
          onClick={() => {
            setScrollPosition(window.scrollY);
            setShowOffcanvas(!showOffcanvas);
          }}
        />
        <Navbar.Offcanvas
          show={showOffcanvas}
          onHide={handleCloseOffcanvas}
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          className="justify-content-between"
        >
          <Offcanvas.Header closeButton />
          <Offcanvas.Body className="textttt">
            <Nav className="navgroup align-items-center w-100 justify-content-between">
              <NavLink to={PATHS.home} onClick={handleCloseOffcanvas}>
                Home
              </NavLink>
              <span className="dropdown">
                <NavHashLink smooth to="/#Services" className="dropbtn">
                  Services
                  <IoMdArrowDropdown />
                </NavHashLink>
                <div className="dropdown-content">
                  {NAV_SERVICES.map((service) => (
                    <NavLink
                      key={service.to}
                      to={service.to}
                      onClick={handleCloseOffcanvas}
                    >
                      {service.label}
                    </NavLink>
                  ))}
                </div>
              </span>
              {HASH_SECTIONS.filter((section) => section.id !== "Services").map(
                (section) => (
                  <NavHashLink
                    key={section.id}
                    smooth
                    to={section.to}
                    onClick={(event) => handleHashLinkClick(event, section.id)}
                  >
                    {section.label}
                  </NavHashLink>
                )
              )}
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
}
